import React from 'react'
import NavigationLayout from 'layouts/Navigation'
import Error from './components/Error'
import { ErrorType } from './components/types'

const App = (props: ErrorType) => (
  <NavigationLayout dataApp='error'>
    <Error {...props} />
  </NavigationLayout>
)

export default App
